var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('option',{domProps:{"selected":_vm.location.code === _vm.selected,"value":_vm.location.code}},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.location.name))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }